<template>
	<Modal class="cc-modal" width="1200" footer-hide v-model="visibility" title="我的域名列表">
		<div class="content" v-if="data">
			<div class="con-row">
				<div style="margin: 0 20px">域名状态：</div>
				<div :class="['item', { active: item.value === searchObj.status }]" v-for="item in domainStatusList"
					:key="item.value" @click="onCheckDomainStatus(item.value)">
					{{ item.name }}
				</div>
			</div>
			<div class="cond-row">
				<div class="item" style="margin-right: 60px">
					<div style="margin-right: 10px">域名：</div>
					<Input class="height45" v-model="searchObj.name" placeholder="请输入要搜索的域名" style="width: 300px"
						clearable />
				</div>
				<div class="item">
					<div style="margin-right: 10px">命名认证：</div>
					<Select class="height45" v-model="searchObj.cerStatus" style="width: 180px" clearable>
						<Option v-for="item in approvedStatusList" :value="item.value" :key="item.value">{{ item.name }}
						</Option>
					</Select>
				</div>
				<div class="item" style="margin-right: 100px">
					<div style="margin-right: 10px">注册 / 转入时间：</div>
					<DatePicker class="height45" :value="registeredAtArr" format="yyyy-MM-dd" type="daterange"
						placement="bottom-end" placeholder="注册 / 转入时间" style="width: 240px"
						@on-change="onRegisteredChange"></DatePicker>
				</div>
				<div class="item" style="margin-right: 60px">
					<div style="margin-right: 10px">过期时间：</div>
					<DatePicker class="height45" :value="expiredStartTimeArr" format="yyyy-MM-dd" type="daterange"
						placement="bottom-end" placeholder="注册 / 转入时间" style="width: 240px"
						@on-change="onExpiredTimeChange"></DatePicker>
				</div>
				<div class="item">
					<Button class="btn-height45" type="primary" style="margin-right: 20px" @click="onSearch">
						搜索</Button>
					<Button class="btn-height45" @click="onSearchCancel"> 重置</Button>
				</div>
			</div>
			<!-- @on-row-click="tableSelect" -->
			<Table class="domain-table" :columns="columns" :data="data" :loading="tableLoading" @on-select="select"
				@on-select-cancel="selectCancel" @on-select-all="($event) => allSelect($event, true)"
				@on-select-all-cancel="($event) => allSelect($event, false)">
			</Table>
		</div>
		<div class="foot">
			<div class="page-tool">
				<Page :current="searchObj.page" :total="searchObj.total" :page-size="searchObj.limit" show-total
					@on-change="onPageChange" />
			</div>
			<div>
				<Button @click="onConfirm" type="primary" style="margin-right: 20px">确定</Button>
				<Button @click="onCancel">取消</Button>
			</div>
		</div>
	</Modal>
</template>
<script>
	import {
		domainList
	} from "api/domain.js";
	import {
		mapActions,
		mapState
	} from "vuex";

	export default {
		name: "domainListModal",
		components: {
		},
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			// 选中的域名
			checkedDomain: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
				tableLoading: false,
				columns: [{
						type: "selection",
						title: "全选",
						width: 60,
						align: "center",
					},
					{
						type: "index",
						title: "序号",
						width: 80,
						align: "center",
					},
					{
						key: "dn",
						title: "域名",
						align: "center",
					},
					{
						key: "regT",
						title: "注册时间",
						align: "center",
					},
					{
						key: "expT",
						title: "过期时间",
						align: "center",
					},
					{
						key: "temp",
						title: "模板",
						align: "center",
					}
				],
				searchObj: {
					status: -1,
					cerStatus: -1,
					// 注册/转入结束时间
					regStartTime: "",
					// 注册/转入开始时间
					regEndTime: "",
					// 过期时间
					expiredStartTime: "",
					expiredEndTime: "",
					// 域名长度
					startExtent: "",
					endExtent: "",
					name: "",
					rule: [],
					page: 1,
					limit: 10,
					total: 0,
				},
				// 域名状态
				domainStatusList: [{
						name: "全部域名",
						value: -1,
					},
					{
						name: "即将到期",
						value: 0,
					},
				],
				// 实名认证
				approvedStatusList: [{
						name: "未认证",
						value: 0,
					},
					{
						name: "认证中",
						value: 1,
					},
					{
						name: "认证成功",
						value: 2,
					},
					{
						name: "认证失败",
						value: 3,
					},
				],
				domainTypeStr: [],
				isAutoRenewList: [{
						name: "否",
						value: 0,
					},
					{
						name: "是",
						value: 1,
					},
				],
				// 转入时间
				registeredAtArr: [],
				expiredStartTimeArr: [],
				data: [],
				value: [], // 选中的数据
				templateListModalVisibility: false,
				templateInfo: {},
			};
		},
		watch: {
			show: {
				immediate: true,
				deep: true,
				handler(val) {
					if (val) {
						this.req_getList();
					}
				},
			},
			checkedDomain: {
				immediate: true,
				handler(val) {
					this.value = val;
				},
			},
		},
		computed: {
			...mapState(["domainQueryData"]),
			visibility: {
				get() {
					return this.show;
				},
				set(val) {
					this.$emit("update:show", val);
				},
			},
		},
		mounted() {
			if (
				this.domainQueryData.domainTypeList.length === 0
			) {
				this.ACT_DOMAIN_QUERY();
			}
		},
		methods: {
			...mapActions(["ACT_DOMAIN_QUERY"]),
			// 获取数据
			async req_getList() {
				try {
					let params = {
						page: this.searchObj.page,
						limit: this.searchObj.limit,
					};
					this.searchObj.status !== -1 &&
						(params.exType = this.searchObj.status);
					this.searchObj.cerStatus !== -1 &&
						(params.rz = this.searchObj.cerStatus);
					this.searchObj.regStartTime &&
						(params.transferInTime = this.searchObj.regStartTime);
					this.searchObj.regEndTime &&
						(params.transferOutTime = this.searchObj.regEndTime);
					this.searchObj.expiredStartTime &&
						(params.strExTime = this.searchObj.expiredStartTime);
					this.searchObj.expiredEndTime &&
						(params.endExTime = this.searchObj.expiredEndTime);
					this.searchObj.name && (params.dn = this.searchObj.name);
					this.tableLoading = true;
					const {
						code,
						data
					} = await domainList(params);
					this.tableLoading = false;
					if (code === 200) {
						let array = data.list.map((o) => {
							let isCheckEd = false;
							if (this.checkedDomain.length > 0) {
								isCheckEd = this.checkedDomain.some((v) => {
									return v === o.name;
								});
							}
							return {
								...o,
								_checked: isCheckEd
							};
						});
						this.data = array;
						this.searchObj.total = data.total;
						// this.total = data.total;
					}
				} catch (error) {
					this.tableLoading = false;
					console.log(error);
				}
			},
			// 取消
			onCancel() {
				this.visibility = false;
			},
			// 搜索
			onSearch() {
				this.onPageChange(1);
			},
			// 重置
			onSearchCancel() {
				this.searchObj = this.$options.data().searchObj;
				this.templateInfo = {};
				this.onPageChange(1);
			},
			// 分页
			onPageChange(val) {
				this.searchObj.page = val;
				this.req_getList();
			},
			// 域名转台改变
			onCheckDomainStatus(val) {
				this.searchObj.domainStatus = val;
				this.onPageChange(1);
			},
			// 日期改变
			onRegisteredChange(event) {
				this.searchObj.regStartTime = event[0];
				this.searchObj.regEndTime = event[1];
			},
			// 日期改变
			onExpiredTimeChange(event) {
				this.searchObj.expiredStartTime = event[0];
				this.searchObj.expiredEndTime = event[1];
			},
			// 确定
			onConfirm() {
				this.$emit("onChecked", this.value);
				this.onCancel();
			},
			// 打开选择模板
			showCheckedTemplate() {
				this.templateListModalVisibility = true;
			},
			// 选中模板回调
			checkedTemplate(val) {
				this.templateInfo = val;
				this.templateListModalVisibility = false;
			},
			// 全选
			allSelect(event, val) {
				this.data.forEach((o, index) => {
					!o._disabled && (o._checked = val);
					this.$set(this.data, index, o);
				});
				let selfData = this.data.map((o) => {
					return o.name;
				});
				// 去重
				if (val) {
					let tempArray = [...this.value, ...selfData];
					this.value = Array.from(new Set(tempArray));
				} else {
					this.value = selfData.filter((o) => !this.value.includes(o));
				}
			},
			// 选中
			select() {
				let row = arguments[1];
				if (!row._disabled) {
					let index = this.data.findIndex((o) => o.dn === row.dn);
					row._checked = true;
					// 对比数据中有没有选中的数据
					!this.value.some((o) => o === row.dn) && this.value.push(row.dn);
					this.$set(this.data, index, row);
				}
			},
			// 取消选中
			selectCancel() {
				let row = arguments[1];
				let index = this.data.findIndex((o) => o.dn === row.dn);
				row._checked = false;
				// 查找下标
				let cindex = this.value.findIndex((o) => o === row.dn);
				cindex !== -1 && this.value.splice(cindex, 1);
				this.$set(this.data, index, row);
			},
		},
	};
</script>
<style lang="less" scoped>
	/deep/ .cc-modal {
		.ivu-table-tip td {
			border-bottom: none;
		}
	}

	.cc-modal {
		.content {
			height: auto;
			min-height: 100px;
			max-height: 500px;
			overflow: auto;
		}

		.foot {
			padding-top: 16px;
			display: flex;
			justify-content: flex-end;
			align-items: center;
		}
	}

	.con-row {
		display: flex;
		height: 40px;
		line-height: 40px;
		margin-bottom: 20px;

		.item {
			font-size: 14px;
			font-weight: 600;
			color: #434063;
			cursor: pointer;
			margin-right: 40px;
			background: #f5f9fe;
			border-radius: 54px;
			border: 1px solid #759de6;
			width: 100px;
			text-align: center;
			line-height: 40px;
		}

		.item.active {
			color: #fff;
			background: #315491;
		}
	}

	.cond-row {
		display: flex;
		flex-wrap: wrap;
		line-height: 60px;

		.item {
			display: flex;
			align-items: center;
			margin: 0 20px;
		}
	}

	.page-tool {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
	}
</style>
